import { createAction } from '@ngrx/store';

export const SetIntegrationsVoluntaryChange = createAction('[Integrations] Set voluntary change');

export const SetIntegrationsInvoluntaryChange = createAction(
  '[Integrations] Set involuntary change'
);
